export default "__VITE_ASSET__B6Ag5O6a__"